import React, { useContext,useEffect,useState } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import { CategorysContext } from '../../context/categorys';
import { MarkContext } from '../../context/mark';

const CardInput = styled.section`

    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.1rem;
    }

    div{
        margin-left:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;

        div{
            margin-left: 0rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;

`
const ImagePreview = styled.img`
    width: 130px;
    height: 130px;
    margin: 0 auto;
    object-fit: contain;
    border-radius: 100px;
`

const ModalEditMark = ({ props }) => {
    const {
        update,
        markName
    } = useContext(MarkContext)

    const [mark,setMark] = useState()

    const handleEditClick = () => {
        update(mark)
        props.onHide(); // Fechar a modal após adicionar
    }

    useEffect(() =>{
        setMark(markName)
    },[markName])


    return (
        
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Informações iniciais</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Nome *"} onChange={(e) => setMark(e.target.value)} value={mark}   />
                    </CardInput>
                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleEditClick()}>Editar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEditMark